import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CustomerShell } from "~/components/shell/CustomerShell";
import { PushBootstrap } from "~/components/push-bootstrap";
import { requireCustomer } from "~/lib/guards";
import { useCustomerStream } from "~/lib/live";

export const Route = createFileRoute("/_authed/_portal")({
  beforeLoad: async ({ context }) => {
    await requireCustomer(context.queryClient);
  },
  component: PortalLayout,
});

function PortalLayout() {
  useCustomerStream();
  return (
    <CustomerShell>
      <PushBootstrap />
      <Outlet />
    </CustomerShell>
  );
}
